module.exports = __webpack_public_path__ + "img/2.c7d05658.png";